"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_link_1 = require("@hotelplan/components.common.link");
const components_common_router_link_1 = require("@hotelplan/components.common.router-link");
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const BreadcrumbList = styled_components_1.default.ul.attrs({
    'data-id': `breadcrumb-list`,
})(({ theme: { fontSizes, media } }) => ({
    fontSize: fontSizes[1],
    [media.tablet]: {
        fontSize: fontSizes[2],
    },
}));
const BreadcrumbLink = (0, styled_components_1.default)(components_common_link_1.Link).attrs({
    'data-id': `breadcrumb-link`,
    className: `breadcrumb-link`,
})(({ delimiter, theme: { space }, theme }) => (0, util_theme_sxc_1.sx2CssThemeFn)(Object.assign(Object.assign({}, theme.link.breadcrumbLink), { display: 'inline', '&:not(:last-child):after': {
        display: 'inline-block',
        content: `"${delimiter}"`,
        marginLeft: space[2],
    } })));
const BreadcrumbLabel = styled_components_1.default.div.attrs({
    'data-id': `breadcrumb-label`,
    className: `breadcrumb-label`,
})(({ disabled, theme: { colors, space } }) => ({
    color: disabled ? `black` : colors.primary,
    cursor: disabled ? 'auto' : 'pointer',
    display: 'inline-block',
    marginRight: space[2],
}));
const Breadcrumb = props => {
    const { items, testId, delimiter = '/', className } = props;
    return (React.createElement(BreadcrumbList, { className: `breadcrumb-list ${className || ''}`, "data-id": testId }, items.map((item, i) => {
        return (React.createElement(React.Fragment, { key: i }, item.disabled || !item.link ? (React.createElement(BreadcrumbLabel, { disabled: item.disabled, onClick: item.onClick }, item.label)) : (React.createElement(components_common_router_link_1.RouterLink, Object.assign({}, item.link, { passHref: true }),
            React.createElement(BreadcrumbLink, { delimiter: delimiter, onClick: item.onClick }, item.label)))));
    })));
};
exports.default = Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map